import script from "./vmsChangePermissions.vue?vue&type=script&lang=js"
export * from "./vmsChangePermissions.vue?vue&type=script&lang=js"

import "./vmsChangePermissions.vue?vue&type=style&index=0&id=57eaeb96&lang=css"
import "./vmsChangePermissions.vue?vue&type=style&index=1&id=57eaeb96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57eaeb96"]])

export default __exports__